import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function Signup() {
  const nav = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const onSignup = async () => {
    setMsg("");
    const cleanEmail = email.trim().toLowerCase();
    const cleanName = displayName.trim();

    if (!cleanName) {
      setMsg("Introduce un nombre o nickname.");
      return;
    }
    if (!cleanEmail || !password) {
      setMsg("Introduce email y contraseña.");
      return;
    }
    if (password.length < 6) {
      setMsg("La contraseña debe tener al menos 6 caracteres.");
      return;
    }

    try {
      setLoading(true);

      const { error } = await supabase.auth.signUp({
        email: cleanEmail,
        password,
        options: {
          emailRedirectTo: `${window.location.origin}/dashboard`,
          data: {
            display_name: cleanName,
          },
        },
      });

      // Si el signup devuelve sesión, entramos
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session) {
        nav("/dashboard");
        return;
      }

      if (error) {
        setMsg("Error: " + error.message);
        return;
      }

      setMsg("Cuenta creada. Revisa tu email para confirmar y luego entra.");
    } catch (e) {
      // Si hubo error raro pero existe sesión, entramos igual
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        if (session) {
          nav("/dashboard");
          return;
        }
      } catch (_) {}

      setMsg("Error inesperado: " + (e?.message || String(e)));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 p-6">
      <div className="w-full max-w-md bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-6">
        <h1 className="text-2xl font-bold text-white mb-2">Crear cuenta</h1>

        <input
          className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-yellow-400 mb-3"
          placeholder="Nombre / Nickname"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          autoComplete="nickname"
        />

        <input
          className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-yellow-400 mb-3"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />

        <input
          type="password"
          className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-yellow-400"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
        />

        <button
          className="mt-4 w-full bg-yellow-400 text-purple-900 px-4 py-3 rounded-lg font-semibold hover:bg-yellow-300 transition disabled:opacity-60"
          onClick={onSignup}
          disabled={loading}
        >
          {loading ? "Creando..." : "Crear cuenta"}
        </button>

        {msg && <p className="mt-3 text-white text-sm">{msg}</p>}

        <p className="mt-4 text-purple-200 text-sm">
          ¿Ya tienes cuenta?{" "}
          <Link className="text-yellow-300 underline" to="/login">
            Entrar
          </Link>
        </p>
      </div>
    </div>
  );
}

